<div *ngIf="onlineStateService.isOffline$ | async" class="offline-toast">
  <p>
    {{ 'offlineEvent' | translate }}
  </p>
</div>
